import React, { useState } from "react";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import logo from "assets/img/visamc.png";
import Button from "common/components/CustomButtons/Button.jsx";
import Payment from "@material-ui/icons/Payment";

import CustomInput from "common/components/CustomInput/CustomInput.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
  visamc: {
    maxWidth: "calc(100px + 20vmin)",
  },
  cssLabel: {
    color: "blue", //required color
  },
};

const AutoPaymentNameOnCard = (props) => {
  const [buttonDisable] = useState(false);
  const { classes } = props;

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Payment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Credit Card</h4>
            </CardHeader>
            <CardBody>
              <GridContainer align="center" justify="center">
                <GridItem xs={12}>
                  <p className={classes.text}>
                    <strong>
                      MCSnet accepts Visa (including Visa Debit) and MasterCard
                      only
                    </strong>
                  </p>
                  <img
                    alt="visa-master-card-logos"
                    src={logo}
                    className={classes.visamc}
                  />
                  <p className={classes.text}>
                    When a new payment method is added to your account it
                    becomes your <strong>default payment method</strong>. Your
                    previous payment information will be automatically left on
                    file as a back up payment method, you can contact us at any
                    time to remove old payment information.
                  </p>
                  <p className={classes.text}>
                    MCSnet uses a card manager service to automatically update
                    some credit card expiration dates. This information is
                    provided by your credit card company; you can opt out of
                    this service by contacting them directly.
                  </p>
                  <p className={classes.text}>
                    If contacting us by email, please do <strong>not</strong>{" "}
                    include credit card numbers or confidential information.
                  </p>
                  <p className={classes.text}>
                    MCSnet does not store or process credit card numbers, this
                    information is directly managed by our credit card
                    processor.
                  </p>
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText={
                      <span style={{ fontWeight: "bold", color: "#2196f3" }}>
                        Name on Card
                      </span>
                    }
                    id={"nameoncard"}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) =>
                        props.setNameOnCard(event.target.value),
                      value: props.nameOnCard,
                      autoComplete: "off",
                    }}
                  />
                  <p style={{ fontWeight: "bold" }}>
                    *If this is a prepaid Visa/Mastercard, please enter the name
                    as "PPC"
                  </p>
                </GridItem>
                <GridItem xs={12}>
                  <Button
                    className={classes.buttonStyle}
                    color="default"
                    disabled={buttonDisable}
                    onClick={props.backToMainScreen}
                  >
                    Back
                  </Button>
                  <Button
                    className={classes.buttonStyle}
                    color="primary"
                    disabled={buttonDisable}
                    onClick={props.handleNext}
                  >
                    Next
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(styles)(AutoPaymentNameOnCard);
